import React from 'react';
import { useGetTrucksQuery } from '../../../redux/slices/truckSlice';
import usePagination from '../../../hooks/usePagination';

// Components
import TruckTease from '../TruckTease';
import Paginate from '../../shared/Paginate';
import Loader from '../../shared/Loader';
import FilterList from './FilterList';

// Styles
import paginateRoundTheme from '../../shared/Paginate-round.module.postcss';
import styles from './Search.module.postcss';

function AllTrucks({ page, query, foodCategories }) {
  const { data = {}, isLoading } = useGetTrucksQuery({
    page_size: 12,
    page,
    ...(query ? { search: query } : {}),
    ...(foodCategories ? { food_categories: foodCategories } : {}),
  });
  const trucks = data.trucks || [];
  const pagination = data.pagination;

  const { paginationProps, showPagination } = usePagination({
    pagination,
    options: { theme: paginateRoundTheme, previousLabel: '<', nextLabel: '>' }
  });

  return (
    <div className='InnerSection'>
      <div className={styles.SearchResults_Header}>
        <h1>All Results</h1>
        <FilterList
          query={query}
          foodCategories={foodCategories}
        />
      </div>

      <Loader isLoading={isLoading}>
        { trucks.length === 0 && <p>No trucks found.</p> }

        { trucks.length > 0 &&
          <div className={styles.AllTrucks}>
            { trucks.map(truck => (
              <TruckTease truck={truck} key={truck.id} />
            )) }
          </div>
        }

        { showPagination && <Paginate {...paginationProps} /> }
      </Loader>
    </div>
  );
}

export default AllTrucks;
